module.exports = __webpack_public_path__ + "img/fyt_p15.947461a3.png";